import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
}));

export default function CTabs(props) {
    const classes = useStyles();
    const t = useTranslations();

    return (
        <div className={classes.root}>
            <Tabs value={props.setActiveTab} variant="fullWidth" aria-label="full width tabs example"
                  onChange={props.handleTabChange.bind(this)} className="tabs-header" indicatorColor="primary"
                  textColor="primary">
                {
                    props.nav.map((item, index) => {
                        const label = item.label;
                        return (
                            <Tab className={`button-mock-tabs ${item.show && "dashboardTab"}`} label={t(label)}
                                 icon={item.icon} key={index}/>
                        );
                    })
                }
            </Tabs>
        </div>
    );
}
